<template>
    <div class="add-announcement-form-container">
        <editAnnouncementMessageModal/>

        <VpFormLayout>
            <template v-slot:content-header>
                <Breadcrumb style="background-color: transparent" :items="items" />
            </template>
            <template v-slot:content-body>
            <div class="addAnnouncement-form">

                <VpInput v-model="title" maxlength="50" type="text" width="416" :placeholder="$t('common.title')" :label="$t('common.title')"/>

                <div class="announcement-notes mt-16">
                    <vp-QuillEditor v-model="description" ref="quillEditor" :placeholder="$t('announcements.form.announcement')"/>
                </div>

                <VpInput v-model="url" type="text" width="416" :placeholder="$t('announcements.form.url')" :label="$t('announcements.form.url')"
                @input="checkUrlValidation" :errMsg="'Invalid URL.'" :invalid="invalidUrl" :class="invalidUrl ? 'mb-34' : ''"/>

                <div class="urgent-announcement mt-16">
                    <p class="label">{{ $t('announcements.form.urgentAnnouncement') }}</p>
                    <b-form-checkbox class="switch-gray announcement-switch" switch size="lg" v-model="urgent" />
                </div>

                <div class="urgent-announcement mt-16">
                    <p class="label">{{ $t('announcements.form.pinnedAnnouncement') }}</p>
                    <b-form-checkbox class="switch-gray announcement-switch" switch size="lg" v-model="pinned" />
                </div>

                <div class="announcement-seperator-line"></div>

                <h6 class="announcement-date-titles" :class="{'vp-mb-16' : userHasPermittedUserTypeOnly || userHasPermittedNonRemoteAreaOnly}">{{ $t('announcements.form.announcementTarget') }}</h6>

                <div class="annoucement-target-note">
                    <p v-if="userHasPermittedUserTypeOnly" ><b>{{ $t('common.notes.note') }} : </b> Publishing announcements at the area level is not allowed  because you do not have access to any non-remote areas.</p>
                    <p v-if="userHasPermittedNonRemoteAreaOnly" ><b>{{ $t('common.notes.note') }} : </b> Publishing announcements at the user type level is not allowed because you do not have access to any "Pre-registered by admin" user types.</p>
                </div>

                <div  class="d-flex date-radios vp-mt-32 vp-mb-32">

                    <v-radio-group v-model="announcementTargetString" name="announcementTargetString" @change="changeAnnouncementTargetString()">
                        <v-radio v-for="option in annoucementTargetOptions" :disabled="option.disabled" :key="option.value" :label="option.text" :value="option.value"/>
                    </v-radio-group>
                   
                </div>

                <VpTreeselect v-if="announcementTargetString == 'user_type'"  zIndex="100" :showPlaceholderIcon="true" width="416" :showOptionsBorder="true" :showNoResults="true"
                    v-model="userTypes" :isLoading="userTypesLoading" :options="userTypesOptions" :allowEmpty="true" :show-labels="true" :isMultiple="true" :flat="true"
                    :label="$t('announcements.form.userType')" :sortValueBy="'INDEX'" noResultMessage="No results found" />
                    <p v-if="update && hasUserTypeDisabled && announcementTargetString == 'user_type'" class="my-2 removing-user-type vp-width-416"><b>Note: </b>Removing user types is not allowed if you are not allowed to access them.</p>

                <div v-if="announcementTargetString == 'area'">

                    <VpTreeselect  zIndex="100" :showPlaceholderIcon="true" width="416" :showOptionsBorder="true" :showNoResults="true"
                    v-model="areas" :isLoading="sitesLoading" :options="sitesOptions" :allowEmpty="true" :show-labels="true" 
                    :isMultiple="true" :flat="true" :autoDeselectDescendants="true" :autoSelectDescendants="true" @deselect="deselectAreaValue"
                    @select="selectAreaValue"
                    :label="$t('common.area')" :sortValueBy="'INDEX'" noResultMessage="No results found" />
                    <p v-if="update && hasSiteDisabled && announcementTargetString == 'area'" class="my-2 removing-user-type vp-width-416"><b>Note: </b>Removing areas is not allowed because you do not have access to them.</p>

                    <div class="d-flex verbalAnnouncement">
                        <b-form-checkbox v-model="verbal" name="verbal" :class="{'checkedLabelColor':verbal}">{{ $t('announcements.form.verbalAnnouncement') }}</b-form-checkbox>
                    </div>
                </div>

                    
                <div class="announcement-seperator-line"></div>

                <h6 class="announcement-date-titles">{{ $t('announcements.form.announcementPublish') }}</h6>

                <div class="d-flex align-items-baseline">
                    <div class="d-flex custom-radios-group custom-radios">

                        <v-radio-group v-model="announcementPublishDateString" name="announcementPublishDateString" @change="changeAnnouncementPublishAndExpirtDateString()">
                            <v-radio v-for="option in announcementPublishOptions" :disabled="option.disabled" :key="option.value" :label="option.text" :value="option.value"/>
                        </v-radio-group>    

                    </div>
                    <div class="d-flex ml-21">
        
                        <div class="mr-15 publish-label">
                            <span class="date-time-labelOne" v-if="announcementPublishDate">
                                {{ $t('announcements.form.publishDate') }}
                            </span>
                            <div :class="invalidAnnouncementPublishDate ? 'is-invalid' :''">
                                <date-picker @input="changeAnnouncementPublishDate" class="pre-reg-datepicker" 
                                :class="announcementPublishDateString != 'customPublishDateTime' ? 'disabledOpacity' :announcementPublishDate ? 'date-with-value': ''" 
                                :first-day-of-week="1" :disabled="announcementPublishDateString == 'customPublishDateTime' ? false : true"
                                value-type="date" v-model="announcementPublishDate" format="DD/MM/Y" :placeholder="$t('announcements.form.publishDate')" :disabledDate="disablePublishDates" >
                                    <i slot="icon-calendar">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                            :fill="announcementPublishDate ? '#103F5E' : '#787878'"/>
                                        </svg>
                                    </i>
                                </date-picker>
                            </div>
                            <div v-if="invalidAnnouncementPublishDate" class="err-wrapper">
                                <div class="announcement-error-message">
                                    <span class="error-value">{{ $t('announcements.form.publishDateCantBeforeToday') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="announcement-publish-time">
                            <span class="date-time-labelOne" v-if="announcementPublishTime">
                                {{ $t('announcements.form.publishTime') }}
                            </span>
                            <div :class="invalidAnnouncementPublishTime ? 'is-invalid' :''">
                                <date-picker @open="checkAnnouncementPublishTime" @input="changeAnnouncementPublishTime" id="publish_time" class="pre-reg-datepicker" 
                                :class="announcementPublishDateString != 'customPublishDateTime' ? 'disabledOpacity' : announcementPublishTime? 'date-with-value' : ''" 
                                :use12h="true" :show-second="false" format="hh:mm A" value-type="date" type="time"
                                    :placeholder="$t('announcements.form.publishTime')" :disabled="announcementPublishDateString == 'customPublishDateTime' ? false : true" v-model="announcementPublishTime"
                                    :default-value="defaultPublishTime" :disabled-time="disablePublishTime"> 
                                    <i slot="icon-calendar">
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                            :fill="announcementPublishTime ? '#103F5E' : '#787878'"
                                            />
                                        </svg>
                                    </i>
                                </date-picker>
                            </div>
                            <div v-if="invalidAnnouncementPublishTime" class="err-wrapper">
                                <div class="announcement-error-message">
                                    <span class="error-value">{{ $t('announcements.form.publishTimeCantBeforeNow') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h6 class="announcement-date-titles">{{ $t('announcements.form.announcementExpiry') }}</h6>


                <div class="d-flex align-items-baseline">

                    <div  class="d-flex custom-radio-group custom-radio">
    
                        <v-radio-group v-model="announcementExpiryDateString" name="announcementExpiryDateString" @change="changeAnnouncementExpiryDateString()">
                            <v-radio v-for="option in announcementExpiryOptions" :disabled="option.disabled" :key="option.value" :label="option.text" :value="option.value"/>
                        </v-radio-group>

                    </div>
                        <!-- </div> -->
                    <div class="d-flex ml-21">
    
                        <div class="mr-15 publish-label">
                            <span class="date-time-labelOne" v-if="announcementExpiryDate">
                                {{ $t('announcements.form.expiryDate') }}
                            </span>
                            <div :class="invalidAnnouncementExpiryDate ? 'is-invalid' :''">
                                <date-picker @input="changeAnnouncementExpiryDate" class="pre-reg-datepicker" :class="announcementExpiryDateString != 'customExpiryDateTime' ? 'disabledOpacity' :announcementExpiryDate ? 'date-with-value' :''" 
                                :first-day-of-week="1" :disabled="announcementExpiryDateString == 'customExpiryDateTime' ? false : true"
                                value-type="date" v-model="announcementExpiryDate" format="DD/MM/Y" :placeholder="$t('announcements.form.expiryDate')" :disabledDate="disableExpiryDates">
                                    <i slot="icon-calendar">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                            :fill="announcementExpiryDate ? '#103F5E' : '#787878'"/>
                                        </svg>
                                    </i>
                                </date-picker>
                            </div>
                            <div v-if="invalidAnnouncementExpiryDate" class="err-wrapper">
                                <div class="announcement-error-message">
                                    <span class="error-value">{{ $t('announcements.form.expiryDateCantbeforeToday') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="publish-label">
                            <span class="date-time-labelOne" v-if="announcementExpiryTime">
                                {{ $t('announcements.form.expiryTime') }}
                            </span>
                            <div :class="invalidAnnouncementExpiryTime ? 'is-invalid' :''">
                                <date-picker @open="checkAnnouncementExpiryTime" @input="changeAnnouncementExpiryTime" id="expiry_time" class="pre-reg-datepicker" :class="announcementExpiryDateString != 'customExpiryDateTime' ? 'disabledOpacity' : announcementExpiryTime ? 'date-with-value' :''"
                                :use12h="true" :show-second="false" format="hh:mm A" value-type="date" type="time"
                                    :placeholder="$t('announcements.form.expiryTime')" :disabled="announcementExpiryDateString == 'customExpiryDateTime' ? false : true" v-model="announcementExpiryTime" 
                                    :default-value="defaultExpiryTime" :disabled-time="disableExpiryTime">
                                    <i slot="icon-calendar">
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                            :fill="announcementExpiryTime ? '#103F5E' : '#787878'"
                                            />
                                        </svg>
                                    </i>
                                </date-picker>
                            </div>
                            <div v-if="invalidAnnouncementExpiryTime" class="err-wrapper">
                                <div class="announcement-error-message">
                                    <span class="error-value">{{ $t('announcements.form.expiryTimeCantBeforeNow') }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                   
                </div>


            </div>
            </template>

            <template v-slot:content-footer>
                <VpButton
                :text="action"
                :disabled="!title || !description || !announcementPublishDateString || !announcementExpiryDateString || isSubmitted
                ? true : announcementPublishDateString == 'customPublishDateTime' && (!announcementPublishDate || !announcementPublishTime) ? true :
                announcementExpiryDateString == 'customExpiryDateTime' && (!announcementExpiryDate || !announcementExpiryTime) ? true  : !invalidUrl && 
                !invalidAnnouncementPublishDate && !invalidAnnouncementPublishTime && !invalidAnnouncementExpiryDate && !invalidAnnouncementExpiryTime && 
                (( announcementTargetString == 'user_type' && userTypes && userTypes.length ) || ( announcementTargetString == 'area' && areas && areas.length )) && !isDirty ? false : true"
                :isLoading="isLoading" :height="'37px'" :width="'151px'" @click="onSubmit()" fontWeight="500" />
            </template>
        </VpFormLayout>
    </div>
</template>
  
<script>
    import { mapActions, mapGetters } from "vuex";
    import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
    import editAnnouncementMessageModal from "@/components/announcements/editAnnouncementMessageModal";
    import moment from "moment";
    
    export default {
        name: "addAnnouncementForm",
        // title: this.$t('announcements.form.addAnnouncement'),
        data() {
            return {
                announcementId : null,
                title : null,
                description : null,
                url : null,
                clear_url : false,
                invalidUrl : false,
                userTypes : [],
                areas : [],
                urgent : false,
                pinned : false,
                verbal : false,
                announcementPublishOptions : [
                    { text: this.$t('announcements.form.immediately'), value: "immediately" },
                    { text: this.$t('announcements.form.customDateAndTime'), value: "customPublishDateTime" },
                ],

                announcementPublishDateString : 'immediately',
                annoucementTargetOptions: [],
                announcementTargetString : 'user_type',
                announcementPublishDate : null,
                invalidAnnouncementPublishDate : false,
                announcementPublishTime : null,
                invalidAnnouncementPublishTime : false,
                announcementExpiryOptions : [
                    { text: this.$t('announcements.form.never'), value: "never" },
                    { text: this.$t('announcements.form.customDateAndTime'), value: "customExpiryDateTime" },
                ],
                announcementExpiryDateString : 'never',
                announcementExpiryDate : null,
                invalidAnnouncementExpiryDate : false,
                announcementExpiryTime : null,
                invalidAnnouncementExpiryTime : false,
                defaultPublishTime : null, 
                defaultExpiryTime : null, 
                userTypesLoading : true,
                sitesLoading : true,
                hasUserTypeDisabled:false,
                hasSiteDisabled:false,
                userTypesOptions : [],
                sitesOptions : [],
                tempUserTypes: [],
                tempAreas: [],
                regUrl : /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\/#[-a-z\d_]*)?$/i,
                items: [
                    {
                        text: this.$t('sideNavbarMenu.announcements.text'),
                        to: { name: "announcements" },
                    },
                    { 
                        text: this.$t('announcements.form.addAnnouncement'),
                        active: true,
                    },
                ],
                isSubmitted : false,
                isLoading : false,
                update : false,
                action : this.$t('common.add'),
                userHasPermittedUserTypeOnly : false,
                userHasPermittedNonRemoteAreaOnly : false,
                sitesIds : [],
                sitesIdsSelected : [],
                isDirty : false,
                fetchedAnnouncementData : {},
                deselectedArea : {},
                selectedArea : {},
            };
        },
        components: {
            Breadcrumb,
            editAnnouncementMessageModal
        },
        computed: {
            ...mapGetters("authfack", [ "currentEntity" ]),
            ...mapGetters("modal", ["getModalInfo"]),
            editor() {
                return this.$refs.quillEditor.quill
            },
        },
        methods: {
            ...mapActions("userType", [ "fetchAllPreRegistrationByAdminUserTypesAndPermittedNormalAreas" ]),
            ...mapActions("announcements", [ "addAnnouncement", "editAnnouncement", "fetchAnnouncement" ]),
            disablePublishDates(date) {
                let currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                let currentMonth = currentDate.getMonth();
                let currentDay = currentDate.getDate();
                return date < new Date(currentYear, currentMonth, currentDay);
            },
            disableExpiryDates(date) {
                let currentDate = new Date();
                if(this.announcementPublishDate){
                    currentDate = new Date(this.announcementPublishDate);
                }                 
                let currentYear = currentDate.getFullYear();
                let currentMonth = currentDate.getMonth();
                let currentDay = currentDate.getDate();
                return date < new Date(currentYear, currentMonth, currentDay);
            },
            disablePublishTime(time){
                let currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                let currentMonth = currentDate.getMonth();
                let currentDay = currentDate.getDate();
                let currentHours = currentDate.getHours();
                let currentMinutes = currentDate.getMinutes() + 5;

                if(this.announcementPublishDate){
                   let announcementPublishDate = new Date(this.announcementPublishDate).getDate();
                   let announcementPublishMonth = new Date(this.announcementPublishDate).getMonth();
                    if(announcementPublishDate == currentDay && announcementPublishMonth == currentMonth){
                        return time < new Date(currentYear, currentMonth, currentDay, currentHours, currentMinutes);
                    }else{
                        return null;
                    }
                }
                return time < new Date(currentYear, currentMonth, currentDay, currentHours, currentMinutes);
            },
            disableExpiryTime(time){
                let currentDate = new Date();
                if(this.announcementPublishTime){
                    currentDate = new Date(this.announcementPublishTime);
                }
                let currentYear = currentDate.getFullYear();
                let currentMonth = currentDate.getMonth();
                let currentDay = currentDate.getDate();
                let currentHours = currentDate.getHours();
                let currentMinutes = currentDate.getMinutes() + 5;
                
                if(this.announcementPublishDate && this.announcementExpiryDate){
                   let announcementPublishDate = new Date(this.announcementPublishDate).getDate();
                   let announcementExpiryDate = new Date(this.announcementExpiryDate).getDate();
                    if(announcementExpiryDate > announcementPublishDate){
                        return null;
                    }else{
                        return time < new Date(currentYear, currentMonth, currentDay, currentHours, currentMinutes);
                    }
                }
                return time < new Date(currentYear, currentMonth, currentDay, currentHours, currentMinutes);
            },
            changeAnnouncementPublishAndExpirtDateString(){
                this.isSubmitted = false;
                this.invalidAnnouncementPublishDate = false;
                this.invalidAnnouncementPublishTime = false;
                this.invalidAnnouncementExpiryDate = false;
                this.invalidAnnouncementExpiryTime = false;
                this.announcementPublishDate = null;
                this.announcementPublishTime = null;
                this.announcementExpiryDate = null;
                this.announcementExpiryTime = null;

                if(this.announcementPublishDateString == 'customPublishDateTime'){
                   this.defaultPublishTime =  new Date((new Date).getTime() + 5 * 60000);
                }

            },
            changeAnnouncementTargetString(){
                if(!this.update){
                    this.userTypes = [];
                    this.areas = [];
                    this.verbal = false;
                }else{
                    if(this.fetchedAnnouncementData.target == 'user_type') this.verbal = false , this.areas = [];
                    if(this.fetchedAnnouncementData.target == 'area') this.userTypes = [];
                }
                this.autoSelectIfParentHasOneChild(this.announcementTargetString);

            },
            changeAnnouncementExpiryDateString(){
                this.isSubmitted = false;
                this.invalidAnnouncementExpiryDate = false;
                this.invalidAnnouncementExpiryTime = false;
                this.announcementExpiryDate = null;
                this.announcementExpiryTime = null;

                if(this.announcementPublishTime){
                    let announcementPublishTime = new Date(this.announcementPublishTime);
                    this.defaultExpiryTime = new Date(announcementPublishTime.getTime() + 5 * 60000);
                }else{
                    this.defaultExpiryTime = new Date((new Date).getTime() + 5 * 60000);
                }  

                // console.log('this.announcementExpiryDateString', this.announcementExpiryDateString);
                
                // this.checkExpiryAnnouncementDateTimeValues();

                // console.log('this.isDirty', this.isDirty);
                // console.log('this.announcementExpiryTime', this.announcementExpiryTime);
                // console.log('this.announcementExpiryTime', this.announcementExpiryTime);
            },
            changeAnnouncementPublishDate(){
                this.isSubmitted = false;
                this.invalidAnnouncementPublishDate = false;
                this.invalidAnnouncementPublishTime = false;
                this.invalidAnnouncementExpiryDate = false;
                this.invalidAnnouncementExpiryTime = false;

                this.defaultPublishTime =  new Date((new Date).getTime() + 5 * 60000);
                if(!this.announcementPublishDate) {
                    this.defaultExpiryTime = new Date((new Date).getTime() + 5 * 60000);
                }
                this.announcementPublishTime = null;
                this.announcementExpiryDate = null;
                this.announcementExpiryTime = null;
            },
            changeAnnouncementPublishTime(){
                this.isSubmitted = false;
                this.invalidAnnouncementPublishTime = false;
                if(!this.announcementPublishTime) {
                    this.defaultPublishTime =  new Date((new Date).getTime() + 5 * 60000);
                    this.defaultExpiryTime = new Date((new Date).getTime() + 5 * 60000);
                }else{
                    let announcementPublishTime = new Date(this.announcementPublishTime);
                    this.defaultExpiryTime = new Date(announcementPublishTime.getTime() + 5 * 60000);
                }
                this.announcementExpiryDate = null;
                this.announcementExpiryTime = null;
            },
            checkAnnouncementPublishTime(){
                let currentDateTime = new Date((new Date).getTime() + 5 * 60000);
                let announcementPublishDate = new Date(this.announcementPublishDate);
                let announcementPublishTime = new Date(this.announcementPublishTime);

                if(announcementPublishTime && currentDateTime > announcementPublishTime && announcementPublishDate.getDate() == currentDateTime.getDate()
                 && announcementPublishDate.getMonth() == currentDateTime.getMonth()){
                    this.announcementPublishTime = null;
                    this.defaultPublishTime =  new Date((new Date).getTime() + 5 * 60000);
                }
            },
            checkAnnouncementExpiryTime(){
                let currentDateTime = new Date((new Date).getTime() + 5 * 60000);
                let announcementExpiryDate = new Date(this.announcementExpiryDate);
                let announcementExpiryTime = new Date(this.announcementExpiryTime);
                
                if(announcementExpiryTime && currentDateTime > announcementExpiryTime && announcementExpiryDate.getDate() == currentDateTime.getDate()
                 && announcementExpiryDate.getMonth() == currentDateTime.getMonth()){
                    this.announcementExpiryTime = null;
                    if(this.announcementPublishTime){
                        let announcementPublishTime = new Date(this.announcementPublishTime);
                        this.defaultExpiryTime = new Date(announcementPublishTime.getTime() + 5 * 60000);
                    }else{
                        this.defaultExpiryTime = new Date((new Date).getTime() + 5 * 60000);
                    }
                }
            },
            changeAnnouncementExpiryDate(){
                this.isSubmitted = false;
                this.invalidAnnouncementExpiryDate = false;
                this.invalidAnnouncementExpiryTime = false;
            },
            changeAnnouncementExpiryTime(){
                this.isSubmitted = false;
                this.invalidAnnouncementExpiryTime = false;
            },
            validateDateTime(currentDate, dateTime, type){
                // console.log('currentDate req', currentDate);
                // console.log('dateTime req', dateTime);
                // console.log('type req', type);


                let currentDateString = moment(new Date(currentDate)).format('YYYY-MM-DD');
                let dateTimeString = moment(new Date(dateTime)).format('YYYY-MM-DD');

                // console.log('currentDateString ', currentDateString);
                // console.log('dateTimeString', dateTimeString);

                if(currentDateString == dateTimeString  && (type == 'publishTime' || type == 'expiryTime')){
                    currentDate = moment(currentDate).format('HH:mm');
                    dateTime = moment(dateTime).format('HH:mm');
                    if(currentDate > dateTime){
                        // console.log('currentDate req time', currentDate);
                        // console.log('dateTime req time', dateTime);

                        if(type == 'publishTime') this.invalidAnnouncementPublishTime = true;
                        if(type == 'expiryTime') this.invalidAnnouncementExpiryTime = true;
                        this.isLoading = false;
                        this.isSubmitted = false;
                        return true;
                    }
                }else if(currentDateString > dateTimeString){
                    // console.log('currentDate req time >>>>>>>>>>>.');
                    if(type == 'publishDate') this.invalidAnnouncementPublishDate = true;
                    if(type == 'expiryDate') this.invalidAnnouncementExpiryDate = true;
                    this.isLoading = false;
                    this.isSubmitted = false;
                    return true;
                }
                return false;
            },
            handleDateTimeFormat(date, time, utc, bySeconds){
                let dateTime = null;
                if(date && time){
                    let yearOfDate = date.getFullYear();
                    let monthOfDate = date.getMonth();
                    let dayOfDate = date.getDate();
                    let hoursOfTime = time.getHours();
                    let minutesOfTime = time.getMinutes();
                    let secondsOfTime = bySeconds ? time.getSeconds() : '00';
                    dateTime = new Date(yearOfDate, monthOfDate, dayOfDate, hoursOfTime, minutesOfTime,secondsOfTime);
                    dateTime = utc ? moment.utc(dateTime).format('YYYY-MM-DD HH:mm:ss') : dateTime;
                }
                return dateTime;
            },
            checkUrlValidation(value){
                this.isSubmitted = false;
                this.invalidUrl = false;
                if (value && !this.regUrl.test(value)) {
                    this.invalidUrl = true;
                }
            },
            editAnnouncementValidation(){
                let currentDateTime = new Date();
                let publishDate = new Date(this.fetchedAnnouncementData.publish_date);

                if((publishDate <= currentDateTime)){
                    this.$bvModal.show("editAnnouncementMessageModal");
                    return true;
                }
                return false;
            },
            autoSelectIfParentHasOneChild(type){

                if(type == 'user_type' && this.userTypesOptions && this.userTypesOptions.length == 1 && !this.userTypes.length){
                    this.selectParentOrFirstChild(this.userTypes, this.userTypesOptions);
                }

                if(type == 'area' && this.sitesOptions && this.sitesOptions.length == 1 && !this.areas.length){
                    this.selectParentOrFirstChild(this.areas, this.sitesOptions);
                }

            },
            selectParentOrFirstChild(array, options){
                if(options[0].children && options[0].children.length == 1 ){
                    array.push(options[0].children[0].id);
                }else if(!options[0].children){
                    array.push(options[0].id);
                }
            },
            async handleClickOutside(event) {
                const containers = await document.querySelectorAll('.vue-treeselect__multi-value-item-container');
                await containers.forEach(container => {
                    const parentItem = container.querySelector('.isJourney');
                    if (!container.contains(event.target) && parentItem) {
                        container.style.display = 'none';
                    }
                });
                this.removeSitesFromValue();
            },
            compareArrays(array1, array2){
                let filteredArray = array1.filter(a => !array2.some(b => a == b));
                // console.log('filteredArray', filteredArray);
                if(filteredArray.length) return true
                else return false;
            },
            async removeSitesFromValue(){
                let filteredSitesArr = [];
                console.log('this.deselectedArea',this.deselectedArea);
                this.areas.map(id => {
                    if( id != this.deselectedArea?.site_id){
                        filteredSitesArr.push(id);
                    }
                });

                if(this.selectedArea && this.sitesIds.includes(this.selectedArea.id) && !filteredSitesArr.includes(this.selectedArea.id)) 
                filteredSitesArr.push(this.selectedArea.id)
                console.log('filteredSitesArr', filteredSitesArr);

                // console.log('filteredSitesArr', filteredSitesArr);
                this.areas = filteredSitesArr;
                this.selectedArea = {};
                this.deselectedArea = {};
                // let isSitesInValues = this.compareArrays(filteredSitesArr, this.areas);
                // console.log('isSitesInValues', isSitesInValues);
                // if(filteredSitesArr.length == this.areas.length && !isSitesInValues ) this.areas = [];
            },
            deselectAreaValue(area){
                // this.areas = [];
                console.log('deselectAreaValue', area);
                this.deselectedArea = area;
            },
            selectAreaValue(area){
                // this.areas = [];
                console.log('selectAreaValue', area);
                this.selectedArea = area;
            },
            
            async checkDirty() {
                let isDirty = true, isUrgent = 0, isPinned = false, isVerbal = false, filteredAreas= [],
                 isPublishDateChanged = false,
                isExpiryDateChanged = false, 
                isTempUserTypeChanged = false, isUserTypeChanged = false, 
                isTempAreasChanged = false, isAreasChanged = false;
                const { fetchedAnnouncementData, title, description, url, urgent, pinned, verbal, announcementTargetString } = this;

                isUrgent = urgent ? 1 : 0;
                isPinned = pinned ? 1 : 0;
                isVerbal = verbal ? 1 : 0;

                isTempUserTypeChanged = this.compareArrays(this.tempUserTypes, this.userTypes);
                isUserTypeChanged = this.compareArrays(this.userTypes, this.tempUserTypes);

                this.areas.map((id) => {
                    if(!this.sitesIds.includes(id)) filteredAreas.push(id);
                });

                isTempAreasChanged = this.compareArrays(this.tempAreas, filteredAreas);
                isAreasChanged = this.compareArrays(filteredAreas, this.tempAreas);
                isPublishDateChanged = this.checkPublishAnnouncementDateTimeValues();
                isExpiryDateChanged = this.checkExpiryAnnouncementDateTimeValues();

                console.log('isPublishDateChanged', isPublishDateChanged);
                console.log('isExpiryDateChanged', isExpiryDateChanged);
                
                if(title != fetchedAnnouncementData.title || url != fetchedAnnouncementData.url 
                || isPublishDateChanged || isExpiryDateChanged
                || isUrgent != fetchedAnnouncementData.urgent || isPinned != fetchedAnnouncementData.is_pinned 
                || isVerbal != fetchedAnnouncementData.is_verbal || isUserTypeChanged || isTempUserTypeChanged ||
                isTempAreasChanged || isAreasChanged || announcementTargetString != fetchedAnnouncementData.target ||
                description != JSON.parse(fetchedAnnouncementData.description)
                ) isDirty = false;

                console.log('isDirty', isDirty);
                this.isDirty = isDirty;
            },
            checkPublishAnnouncementDateTimeValues(){
                let isPublishDateChanged = false;
                let { fetchedAnnouncementData, announcementPublishDate, announcementPublishTime } = this;
                if(fetchedAnnouncementData && fetchedAnnouncementData.publish_date ){                    
                    if(announcementPublishDate && announcementPublishTime){
                        let oldPublishDate = this.handleDateTimeFormat(new Date(fetchedAnnouncementData.publish_date), new Date(fetchedAnnouncementData.publish_date), false, false); 
                        let newPublishDate = this.handleDateTimeFormat(announcementPublishDate, announcementPublishTime, false, false); 
                        if(oldPublishDate.toString() != newPublishDate.toString()) {
                            isPublishDateChanged = true;
                        }
                    }else if(fetchedAnnouncementData && fetchedAnnouncementData.publish_date && this.announcementPublishDateString == 'immediately'){
                        isPublishDateChanged = true;
                        console.log('immediately');
                    }
                } 
                // console.log('isPublishDateChanged', isPublishDateChanged);
                return isPublishDateChanged;
            },
            checkExpiryAnnouncementDateTimeValues(){
                let isExpiryDateChanged = false;
                let { fetchedAnnouncementData, announcementExpiryDate, announcementExpiryTime } = this;
                if(fetchedAnnouncementData && fetchedAnnouncementData.expiry_date &&  this.announcementExpiryDateString == 'customExpiryDateTime'){
                    if(announcementExpiryDate && announcementExpiryTime){
                        let oldExpiryDate = this.handleDateTimeFormat(new Date(fetchedAnnouncementData.expiry_date), new Date(fetchedAnnouncementData.expiry_date), false, false);
                        let newExpiryDate = this.handleDateTimeFormat(announcementExpiryDate, announcementExpiryTime, false, false);    
                        // console.log('oldExpiryDate', oldExpiryDate);
                        // console.log('newExpiryDate', newExpiryDate);
                        if(newExpiryDate.toString() != oldExpiryDate.toString()) {
                            isExpiryDateChanged = true;   
                        }
                    }
                }
                else if(fetchedAnnouncementData && fetchedAnnouncementData.expiry_date && this.announcementExpiryDateString == 'never') {
                    isExpiryDateChanged = true;
                }else if(fetchedAnnouncementData && !fetchedAnnouncementData.expiry_date && this.announcementExpiryDateString == 'customExpiryDateTime'){
                    isExpiryDateChanged = true;

                }
                // console.log('isExpiryDateChanged', isExpiryDateChanged);
                return isExpiryDateChanged;

            },   
            async onSubmit(){
                this.isSubmitted = true;
                this.isLoading = true;
                let currentDate = new Date();
                let { title, description, url, userTypes, areas, urgent, pinned, verbal, announcementTargetString, announcementPublishDateString, 
                    announcementPublishDate, announcementPublishTime, announcementExpiryDateString, 
                    announcementExpiryDate, announcementExpiryTime, currentEntity, 
                    addAnnouncement, editAnnouncement, update, sitesIds } = this;

                if(update){
                    let editAnnouncementValidation = this.editAnnouncementValidation();
                    if(editAnnouncementValidation) return;
                }
                let publishDate = 
                announcementPublishDate && announcementPublishTime ? this.handleDateTimeFormat(announcementPublishDate, announcementPublishTime, false, true) 
                : this.handleDateTimeFormat(currentDate, currentDate, true, true);
                let expiryDate = this.handleDateTimeFormat(announcementExpiryDate, announcementExpiryTime, false, true);

                let announcementPublishDateValidation = announcementPublishDateString != 'immediately' ? this.validateDateTime(currentDate, publishDate, 'publishDate') : false;
                let announcementPublishTimeValidation = announcementPublishDateString != 'immediately' ? this.validateDateTime(currentDate, publishDate, 'publishTime') : false;
                let announcementExpiryDateValidation = announcementExpiryDateString != 'never' ? this.validateDateTime(currentDate, expiryDate, 'expiryDate') : false;
                let announcementExpiryTimeValidation = announcementExpiryDateString != 'never' ? this.validateDateTime(currentDate, expiryDate, 'expiryTime') : false;

                if(announcementPublishDateValidation || announcementPublishTimeValidation || 
                announcementExpiryDateValidation || announcementExpiryTimeValidation) return ;

                let publishDateUTC = 
                announcementPublishDate && announcementPublishTime ? this.handleDateTimeFormat(announcementPublishDate, announcementPublishTime, true, true) 
                : this.handleDateTimeFormat(currentDate, currentDate, true, true);
                let expiryDateUTC = this.handleDateTimeFormat(announcementExpiryDate, announcementExpiryTime, true, true);
                
                areas = await areas.filter((id) => {
                    if(!sitesIds.includes(id) ) {
                        return id;
                    }
                });

                let data = {
                    entity_id : currentEntity.id,
                    server_name : process.env.VUE_APP_SERVER_NAME,
                    title : title,
                    description : JSON.stringify(description),
                    url : url,
                    clear_url : url ? 0 : 1,
                    urgent : urgent ? 1 : 0,
                    is_pinned : pinned ? 1 : 0,
                    is_verbal : verbal ? 1 : 0,
                    target : announcementTargetString,
                    userTypeId : announcementTargetString == 'user_type' ? userTypes : [],
                    areaId : announcementTargetString == 'area' ? areas : [],
                    immediately : announcementPublishDateString == 'immediately' ? 1 : 0,
                    publish_date : publishDateUTC,
                    expiry_date : announcementExpiryDateString != 'never' ? expiryDateUTC : null ,
                }

                // console.log('dataaaaa', data);

                if(update){
                    editAnnouncement({
                        id : this.announcementId,
                        data : data,
                    }).then(()=>{
                        // console.log('resss', res);
                        this.$router.push({ path: `/announcements` });
                    }).catch((e)=>{
                        console.log('e', e);
                    });
                }else{
                    addAnnouncement(data).then(()=>{
                        // console.log('resss', res);
                        setTimeout( () => {
                            this.$router.push({ path: `/announcements` });
                        },500)
                    }).catch((e)=>{
                        console.log('e', e);
                    });
                }  
            },
        },
        watch : {
            title: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            description: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            url: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            urgent: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            pinned: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementTargetString: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            areas: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            userTypes: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            verbal: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementPublishDateString: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementPublishDate: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementPublishTime: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementExpiryDateString: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementExpiryDate: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
            announcementExpiryTime: {
                handler: 'checkDirty',
                deep: true,
                immediate: true
            },
        },
        created() {
            document.addEventListener('click', this.handleClickOutside);
        },
        async beforeMount() {

            if (this.$route.query.id) {
                this.items[1].text = this.$t('announcements.form.editAnnouncement');
                this.update = true;
                this.action = this.$t('common.edit');
                await this.fetchAnnouncement(this.$route.query.id).then( (data) => {
                    // console.log('Announcement', data);
                    this.fetchedAnnouncementData = data;
                    this.announcementId = data.id;
                    this.title = data.title;
                    this.description = JSON.parse(data.description);
                    this.urgent = data.urgent  ? true : false;
                    this.url = data.url;
                    this.pinned = data.is_pinned  ? true : false;
                    this.verbal = data.is_verbal  ? true : false;
                    this.announcementTargetString =  data.target ;
                    if(data.userTypes){
                        data.userTypes.map((userType)=>{
                            this.tempUserTypes.push(userType.id);
                        });
                    }
                    if(data.areas){
                        data.areas.map((area)=>{
                            this.tempAreas.push(area.id);
                            if(!this.sitesIdsSelected.includes(area.site_id)){
                                this.sitesIdsSelected.push(area.site_id);
                            }
                        });
                    }
                    let publishDate = new Date(data.publish_date);
                    let expiryDate = data.expiry_date ? new Date(data.expiry_date) : null;
                    let createdAt = new Date(data.created_at);

                    // console.log('publishDate', publishDate);
                    // console.log('expiryDate', expiryDate);
                    // console.log('createdAt', createdAt);

                    if(publishDate == createdAt){
                        this.announcementPublishDateString = 'immediately';
                    }else{
                        this.announcementPublishDateString = 'customPublishDateTime';
                        this.announcementPublishDate = publishDate;
                        this.announcementPublishTime = publishDate;
                    }

                    if(!expiryDate){
                        this.announcementExpiryDateString = 'never';
                    }else{
                        this.announcementExpiryDateString = 'customExpiryDateTime';
                        this.announcementExpiryDate = expiryDate;
                        this.announcementExpiryTime = expiryDate;
                    }

                    this.disablePublishTime();
                    this.disableExpiryTime();
                    this.disablePublishDates();
                    this.disableExpiryDates();
                    
                });
            }

            await this.fetchAllPreRegistrationByAdminUserTypesAndPermittedNormalAreas({
                method : 'PRE_REGISTERED_BY_ADMIN',
                type: this.update ? 'update' : 'create',
                userTypeIdsSelected: this.update ? this.tempUserTypes?.join(",") : [],
                siteIdsSelected: this.update ? this.sitesIdsSelected?.join(",") : [],
            }).then(async (data)=>{
                this.userTypesOptions = await data.data.user_types;
                this.sitesOptions = await data.data.sites;

                await this.sitesOptions.map( async (site) => {
                    site.isJourney = await true;

                    this.sitesIds.push(site.id);
                });

                if(data.data.user_types.length && !data.data.sites.length){
                    this.userHasPermittedUserTypeOnly = true;
                }
                if(data.data.sites.length && !data.data.user_types.length){
                    this.userHasPermittedNonRemoteAreaOnly = true;
                    this.announcementTargetString = 'area';
                }
            });

            
            this.userTypes = this.tempUserTypes;
            this.areas = this.tempAreas;
            this.userTypesLoading = false;
            this.sitesLoading = false;
            this.userTypesOptions?.map((userType) => {
                if(userType.isDisabled) this.hasUserTypeDisabled = true;
                else userType.children?.map( (sub) => {
                    if(sub.isDisabled) this.hasUserTypeDisabled = true;
                })                
            });
            this.hasSiteDisabled = this.sitesOptions?.some(site => site.isDisabled);
            this.annoucementTargetOptions =  [
                { text: this.$t('announcements.form.userType'), value: "user_type", disabled: this.userHasPermittedNonRemoteAreaOnly },
                { text: this.$t('common.area'), value: "area", disabled: this.userHasPermittedUserTypeOnly },
            ];

            if(!this.update) 
            this.autoSelectIfParentHasOneChild(this.announcementTargetString);
        },
    };
</script>

<style lang="scss">
.add-announcement-form-container .mx-input::placeholder{
    font-weight: 700 !important;
}

.removing-user-type{
        color: #787878;
        width: 376px!important;
        margin-inline-start: 20px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 135.714% */
        letter-spacing: 0.25px;
    }
    input.md-input::placeholder{
        color: #606060!important;
    }
    .publish-label {
        position: relative;
    }
    .pre-reg-datepicker.mx-datepicker.date-with-value {
        input.mx-input{
            
            padding-top: 20px!important;
        }
    }
    .announcement-publish-time {
        position: relative;
    }
    span.date-time-labelOne {
        top: 5px; 
        /* bottom: 10px; */
        color: var(--Main-Button, #103F5E);
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 17px;
        letter-spacing: 0.25px;
        position: absolute;
        /* z-index: 99999; */
        z-index: 2;
        padding-inline-start: 12px;
        padding-bottom: 5px!important;
        margin-bottom: 5px!important;
    }
    .pre-reg-datepicker.mx-datepicker{
        width: 200px!important;
        
    }
    .mr-15.publish-label {
        position: relative;
    } 
    .d-flex.custom-radios-group.custom-radios {
        display:flex!important;
    }
    .date-radios{
        display: flex;
        align-items: center;
        //////////////
        input#customPublishDateTime{
            margin-inline-start: 44px;
            position: relative;
            margin-inline-end:16px;
            
        }
        input#customExpiryDateTime{
        margin-inline-start: 44px;
            position: relative;
            margin-inline-end:16px; 
        }

        input[type='radio']:after {
            width: 20px;
            height: 20px;
            border-radius: 15px;
            position: absolute;
            top: -2px;
            inset-inline-start: -2px;
            /* margin-inline-end: 16px; */
            background-color: #ffffff;
            content: "";
            display: inline-block;
            visibility: visible;
            border: 3px solid #103F5E;
            
        }

        input[type=radio]:after:disabled {
            background-color: #C1C1C1 !important;
        }

        input[type='radio']:checked:before {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            top: 3px;
            inset-inline-start: 2px;
            background-color: #103F5E;
            z-index: 2;
            content: "";
            position: absolute;
            left: 3px;
            right: 3px;
        }

    input[type="radio"]:checked+label {
            color: #103F5E!important;
            font-size: 16px!important;
            font-style: normal!important;
            font-weight: 700!important;
            line-height: normal!important;
            letter-spacing: 0.25px!important;
            margin-top: 10px;
        }
        input[type="radio"]+label {
            color: var(--787878, #787878);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 17px; /* 106.25% */
            letter-spacing: 0.25px;
            margin-top: 10px;
        }
        
        input#immediately{
            position: relative;
            margin-inline-end:16px;
            
        }

        input#userTypeTarget{
            position: relative;
            margin-inline-end:16px;    
        }

        input#areaTarget{
            margin-inline-start: 44px;
            position: relative;
            margin-inline-end:16px; 
        }

        input#never{
        position: relative;
            margin-inline-end:16px; 
        }
    }

    svg.vue-treeselect__control-arrow{
        fill:#636161!important;
    }
    .custom-switch.b-custom-control-lg .custom-control-label::before{
        background: #D1D1D1!important;
    }

    .verbalAnnouncement {
        margin-top: 32px;
        font-size: 16px;
        line-height: 19.2px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color : #787878;      
        label.custom-control-label {
          padding-inline-start: 16px;
          font-weight: 600;
        }
    }

    .checkedLabelColor{
        color: #103F5E;
        label.custom-control-label{
            font-weight: 700;
        }
    }

</style>
  
<style lang="scss" scoped>
    .addAnnouncement-form {
        min-height: 693px !important;
        background-color: white;
        padding: 32px;
        border-radius: 8px;
    }
    .announcement-notes{

        color: rgba(96, 96, 96, 0.87);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 106.25% */
        letter-spacing: 0.25px;
        width: 416px !important;
        margin-top: 16px;
        flex-shrink: 0;
        background: #F2F2F2!important;
        resize: none;
    }

    .urgent-announcement{
        width: 415px;
        height: 55px;
        flex-shrink: 0;
        border-radius: 4px;
        background: #F2F2F2;
        display: flex;
        position: relative;

      .label {
        color: var(--787878, #787878);
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 18px;
        margin-inline-start: 20px;
        margin-inline-end: 171px;
      }

      .announcement-switch{
        margin-top: 14px;
        margin-left: 20px;
        margin-right: 20px;
        margin-inline-start: auto !important;
      }
    }

    .mt-16{
        margin-top: 16px !important;
    }
    .mt-5{
        margin-top: 5px !important;
    }

    .announcement-seperator-line{
        height:1px;
        margin:32px 0px 0px 0px;
        background: #000000;
        opacity: 0.08;
    }

    .announcement-date-titles{
        color: #787878;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.25px;
        margin-top: 32px;
        margin-bottom: 32px;
    }  

    .mr-15{
        margin-inline-end: 15px;
    }

    .mr-24{
        margin-inline-end: 24px;
    }

    .mt-14{
        margin-top: 14px;
    }
    .ml-21{
        margin-inline-start: 21px;
    }

    .custom-editor-wrapper {
        border: 1px solid #ccc;
        padding: 4px;
        margin: 1rem;
        max-width: 640px;
        border-radius: 4px;
        box-shadow: 0 3px 0px -1px rgba(0, 0, 0, .05);
        background-color : red;
    }

    .disabledOpacity{
        opacity: 0.4;
    }
    .mb-34{
        margin-bottom: 34px !important;
    }

    .is-invalid {
        border: 1.5px solid #f46a6a!important;
        border-radius: 4px;
    }

    .announcement-error-message{
        margin-top: 8px;
        margin-inline-start: 20px;
        width:160px;
        .error-value {
            font-weight: 600!important;
            font-size: 14px!important;
            line-height: 22px!important;
            padding-inline-start: 0px!important;
            letter-spacing: 0.25px!important;
            color: #F46A6A!important;
        }
    }

    .annoucement-target-note{
        width: 416px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #787878;


    }

</style>
